<template>
    <div class="drag-wrrapper" :class="{success: confirmSuccess}">
      <div class="drag" ref="dragDiv" >
        <div class="drag_bg"></div>
        <div class="drag_text">{{confirmWords}}</div>
        <div 
          ref="moveDiv" 
          @touchstart="mousedownFn($event)" 
          @mousedown="mousedownFn($event)" 
          class="handler" 
          style="position: absolute;top: 0px;left: 0px;">
          <van-icon v-if="confirmSuccess" name="success" color="#07c160" size="32" />
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data(){
    return {
      beginClientX: 0,              /*距离屏幕左端距离*/
      mouseMoveStata: false,        /*触发拖动状态  判断*/
      maxwidth: '',                 /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords: '拖动滑块验证',  /*滑块文字*/
      confirmSuccess: false,         /*验证成功判断*/
      isMobile: app.base.isMobile || app.base.isIDevice
    }
  },
  methods: {
    //mousedown 事件 
    // 开始监听move或者touchstart事件
    mousedownFn (e) {
      if(!this.confirmSuccess){
        e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true;
        this.beginClientX = this.getClientX(e);
        this.addEvListener();
      }
    }, 
    //验证成功函数       
    successFunction(){
      // 已经成功过，直接退出
      if (this.confirmSuccess) return false;
      this.confirmSuccess = true
      this.confirmWords = '验证通过';
      if(window.addEventListener){
          document.getElementsByTagName('html')[0].removeEventListener('touchmove',this.mouseMoveFn);
          document.getElementsByTagName('html')[0].removeEventListener('touchend',this.moseUpFn);
      }else {
          document.getElementsByTagName('html')[0].removeEventListener('touchend',()=>{});
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
      this.$emit('success');
    },    
    //mousemove事件            
    mouseMoveFn(e){
      if(this.mouseMoveStata){
        let width = this.getClientX(e)  - this.beginClientX;
        if(width>0 && width<=this.maxwidth){
            document.getElementsByClassName('handler')[0].style.left = width + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
        }else if(width>this.maxwidth){
            this.successFunction();
        }
      }
    }, 
    //mouseup事件                  
    moseUpFn(e){
      this.mouseMoveStata = false;
      var width = this.getClientX(e) - this.beginClientX;
      if(width<this.maxwidth){
        document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      }
      this.removeExListener();
    },
    getClientX (e) {
      return this.isMobile ? e.changedTouches[0].clientX : e.clientX;
    },
    addEvListener () {
      if (this.isMobile) {
        document.getElementsByTagName('html')[0].addEventListener('touchmove',this.mouseMoveFn);
        document.getElementsByTagName('html')[0].addEventListener('touchend',this.moseUpFn);
      } else {
        document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
        document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn);
      }
    },
    removeExListener () {
      if (this.isMobile) {
        document.getElementsByTagName('html')[0].removeEventListener('touchmove',this.mouseMoveFn);
        document.getElementsByTagName('html')[0].removeEventListener('touchend',this.moseUpFn);
      } else {
        document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
        document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
      }   
    }              
  },
  mounted(){
    this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
  }
}
</script>

<style lang="scss" scoped>
.drag-wrrapper{
  position: relative;
  background-color: var(--g2);
  border: 1px solid var(--g3);
  width: 100%;
  height: 50px;
  border-radius: 4px;
  text-align: center;  
  color: var(--g7);
  font-size: var(--fs-lg);
  overflow: hidden;
  &.success{
    background-color: var(--c1);
  }
}
.drag{
  height: 100%;
  line-height: 48px;
}
.handler{
  display: flex;
  height: 48px;
  width: 50px;
  background-color: var(--g2);
  &::before{
    margin: 0 1px;
    position: absolute;
    content: "";
    width: 46px;
    height: 46px;
    border: 1px solid var(--g3);  
    border-radius: 2px;
    cursor: move;
    align-items: center;
    justify-content: center;
    background: #fff;
    z-index: 0;
  }
  .van-icon-success{
    position: absolute;
    margin: auto;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 32px;
    height: 32px;
  }

}
.drag_bg{
  // background-color: var(--c1);
  background-color: #8070F5;
  height: 100%;
  width: 0px;
}
.drag_text{
  position: absolute;
  top: 0px;
  width: 100%;text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}
</style>